import { byokFetch } from "./client";
import type { ByokKey } from "../types";

export async function testByokKey(id: string): Promise<ByokKey> {
  return byokFetch<ByokKey>("byok-keys", `/${id}/test`, { method: "POST" });
}
